module.exports = __webpack_public_path__ + "img/10.356aa166.jpg";